import SubHeader from '../components/SubHeader';
import Icon from '../components/Icon';

/**
 * Contact page — tailored layout with a hero intro, a row of method cards,
 * and a preferred-contact note. Replaces the older center-aligned list.
 */
export default function ContactPage() {
  return (
    <>
      <SubHeader title="CONTACT" />
      <div className="site-page with-subheader contact-page">
        <div className="container">
          <div className="contact-wrap">
              <header className="contact-hero">
                <p className="contact-eyebrow">Get in touch</p>
                <h1 className="contact-headline">Let's build something together.</h1>
                <p className="contact-lede">
                  Whether you're hiring, collaborating, or just want to say hello — I'm always open
                  to a good conversation. Pick whichever channel works best for you.
                </p>
              </header>

              <div className="contact-grid">
                <a className="contact-card" href="mailto:cbous1@gmail.com">
                  <span className="contact-card__icon" aria-hidden="true">
                    <Icon name="mail" size={22} />
                  </span>
                  <span className="contact-card__label">Email</span>
                  <span className="contact-card__value">cbous1@gmail.com</span>
                  <span className="contact-card__hint">Usually fastest</span>
                </a>

                <a className="contact-card" href="tel:2035061223">
                  <span className="contact-card__icon" aria-hidden="true">
                    <Icon name="phone" size={22} />
                  </span>
                  <span className="contact-card__label">Phone</span>
                  <span className="contact-card__value">(203) 506-1223</span>
                  <span className="contact-card__hint">Mon – Fri, 9a – 6p ET</span>
                </a>

                <div className="contact-card contact-card--static">
                  <span className="contact-card__icon" aria-hidden="true">
                    <Icon name="map-pin" size={22} />
                  </span>
                  <span className="contact-card__label">Location</span>
                  <span className="contact-card__value">Orlando, FL</span>
                  <span className="contact-card__hint">Open to remote work</span>
                </div>
              </div>

              <footer className="contact-footnote">
                Prefer email for anything detailed — phone is best for quick conversations.
              </footer>
          </div>
        </div>
      </div>
    </>
  );
}
